import React from 'react';

const SocialWorkers: React.FC = () => {
  return <div>SocialWorkers</div>;
};
export default SocialWorkers;
